import './SW.scss';
import clsx from 'clsx';
import { useCallback, useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

import { IClose, IRefresh } from './assets/icons';
import { useAppSelector, useTranslation } from './hooks';
import { persistApiState } from './store';
import { logError, logInfo } from './utils/loggers';
import { persistRdpsState } from './utils/overlay';

function SW() {
  const t = useTranslation();
  const layoutMode = useAppSelector((state) => state.settings.layoutMode);
  const active = useAppSelector((state) => state.api.data.active);
  const [deferredRefresh, setDeferredRefresh] = useState(false);

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      logInfo('service worker registered', r);
    },
    onRegisterError(e) {
      logError('service worker registration error', e);
    },
  });

  const handleClose = useCallback(() => {
    setOfflineReady(false);
    setNeedRefresh(false);
  }, [setNeedRefresh, setOfflineReady]);

  const handleUpdate = useCallback(() => {
    persistApiState();
    persistRdpsState();
    if (active) {
      setDeferredRefresh(true);
      return;
    }
    void updateServiceWorker(true);
  }, [active, updateServiceWorker]);

  useEffect(() => {
    if (!deferredRefresh || active) return;
    persistApiState();
    persistRdpsState();
    void updateServiceWorker(true);
  }, [active, deferredRefresh, updateServiceWorker]);

  return offlineReady || needRefresh ? (
    <div
      className={clsx({
        sw: true,
        'sw-reverse': layoutMode === 'reverse',
      })}
    >
      <div className='sw-text'>
        {offlineReady ? t('App Ready to Work Offline') : t('Refresh to New Version Available')}
      </div>
      {offlineReady ? (
        <div className='sw-btn' onClick={handleClose}>
          <IClose />
        </div>
      ) : (
        <div className='sw-btn' onClick={handleUpdate}>
          <IRefresh />
        </div>
      )}
    </div>
  ) : null;
}

export default SW;
